import colors from 'styles/colors'

const styles = {
  providerInfo: {
    container: {
      padding: '13px 0',
      borderRight: 'none'
    }
  },
  sectionHeader: {
    color: colors.darkStormy,
    fontFamily: 'Barlow',
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: 0,
    lineHeight: '14px'
  },
  toggle: {
    container: {
      marginTop: '1.5em'
    }
  },
  link: {
    color: colors.primary,
    fontFamily: 'Barlow',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '17px',
    cursor: 'pointer'
  },
  actionText: {
    display: 'flex',
    fontSize: 10,
    fontFamily: 'Barlow',
    fontWeight: 700,
    lineHeight: '15px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    alignItems: 'center',
    color: colors.lightGray
  },
  disabledAction: {
    color: colors.olderGray
  },
  noTimeSlotError: {
    color: colors.strawberrySpinachRed,
    marginRight: 'auto',
    marginTop: 0,
    marginBottom: 0,
    order: 1,
    fontFamily: 'Barlow',
    fontSize: 14,
    fontWeight: 500
  },
  visitContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  buttonVisit: {
    button: {
      width: 310,
      marginRight: 0,
      marginTop: 19
    }
  },
  textDividerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    margin: '11px 0'
  },
  line: {
    width: '100%',
    height: 1,
    backgroundColor: colors.pixelWhite
  },
  textDivider: {
    minWidth: 160,
    margin: '0 14px',
    fontFamily: 'Barlow',
    fontSize: 14,
    fontWeight: 600,
    color: colors.grey
  }
}

styles.modalNext = {
  ...styles.modal,
  buttonsContainer: {
    flexDirection: 'row-reverse'
  }
}

styles.modalBack = {
  ...styles.modal,
  buttonsContainer: {
    flexDirection: 'row'
  }
}

export default styles
